import { Flex, Button, Text, CallPstnIcon } from "@fluentui/react-northstar";
import React from "react";
import { useTranslation } from "react-i18next";

import { getBrowserLocale } from "../../localization-provider/utils/getBrowserLocale";

import { useResultsStartAudioTestButton } from "./ResultsStartAudioTestButton.styles";
import { ResultsStartAudioTestButtonProps } from "./ResultsStartAudioTestButton.types";

export const ResultsStartAudioTestButton: React.FC<
  ResultsStartAudioTestButtonProps
> = ({ dispatchAudioTest, isInfoFetched, isAcsTokenFetched }) => {
  const startAudioTestButtonStyles = useResultsStartAudioTestButton();
  const { t } = useTranslation();
  const locale = getBrowserLocale();

  // If the local starts with en, then it is supported
  const isLocaleSupported = locale.startsWith("en");

  if (isAcsTokenFetched && isLocaleSupported) {
    return (
      <Flex>
        <Button
          className="focus-button"
          data-testid="startAudioTestButton"
          aria-label={t("TEST_CALL_START_PROMPT_A11Y_LABEL")}
          onClick={dispatchAudioTest}
          styles={startAudioTestButtonStyles.testCallButton}
          icon={<CallPstnIcon />}
          iconPosition="before"
          disabled={!isInfoFetched}
          secondary
          content={
            <Text
              content={<>{t("TEST_CALL_BUTTON_TEXT")}</>}
              size="medium"
              weight="semibold"
              align="center"
            />
          }
        />
      </Flex>
    );
  } else return null;
};
